import { Link } from "react-router-dom";
import { FileStack, FileText, Table2, } from "lucide-react";
import { Section, SectionHeading, PageHero } from "../components/site/section";
import { PageCta } from "../components/site/page-cta";
import { Button } from "../components/ui/button";
import { asset } from "../lib/assets";

const airtableLogo = { url: asset("airtable-logo-stacked-color.png") };

const reports = [
    {
        title: "Comprehensive Property Report (CPR)",
        body: "A detailed, on-demand report that brings together critical information about an NYC property in one place. From ownership and zoning to building systems, occupancy, violations, filings, and historical records, the CPR provides a comprehensive snapshot for due diligence and informed decision-making.",
        icon: FileStack,
        category: "Comprehensive Property Report Request",
    },
    {
        title: "Property Status Report (PSR)",
        body: "A recurring report designed to keep you informed about the current status of your property. The PSR summarizes recent violations, permits, complaints, filings, compliance activity, upcoming deadlines, and other important changes so you can quickly identify what needs attention.",
        icon: FileText,
        category: "Property Status Report Request",
    },
];
function Services() {
    return (<>
      <PageHero title="Reports, integrations and support." description="From automated Airtable sync to comprehensive property reports, Violerts gives you the data products and managed services that keep portfolios compliant."/>

      <Section>
        <SectionHeading title="Property reports that tell the whole story." description="Two standardized report formats designed for acquisitions, refinancing, insurance renewals and internal portfolio reviews." align="center"/>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {reports.map((r) => (<div key={r.title} className="flex h-full flex-col rounded-[2rem] border border-border bg-card p-8 transition-colors hover:border-foreground/25 md:p-10">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-foreground/5">
                <r.icon className="h-6 w-6 text-foreground"/>
              </div>
              <h3 className="mt-6 text-xl font-bold md:text-2xl">{r.title}</h3>
              <p className="mt-3 leading-relaxed text-muted-foreground">
                {r.body}
              </p>
              <div className="mt-auto pt-6">
                <Button asChild variant="outline">
                  <Link to={`/contact?category=${encodeURIComponent(r.category)}`}>Request</Link>
                </Button>
              </div>
            </div>))}
        </div>
      </Section>

      <Section>
        <div className="grid gap-10 md:grid-cols-2 md:items-center">
          <div>
            <SectionHeading title="Airtable integration" description="Sync live violation, complaint and permit data directly into your Airtable bases so your team can build views, dashboards and workflows on top of Violerts data. Available on the Enterprise plan."/>
            <ul className="mt-8 space-y-4 text-foreground">
              <li className="flex items-start gap-3">
                <Table2 className="mt-0.5 h-5 w-5 shrink-0 text-foreground"/>
                <span>One base per portfolio with tables for properties, violations, complaints and permits.</span>
              </li>
              <li className="flex items-start gap-3">
                <Table2 className="mt-0.5 h-5 w-5 shrink-0 text-foreground"/>
                <span>Records update automatically as agency data changes — no manual CSV imports.</span>
              </li>
              <li className="flex items-start gap-3">
                <Table2 className="mt-0.5 h-5 w-5 shrink-0 text-foreground"/>
                <span>Link to your own CRM, rent roll or asset-management tables with native Airtable relations.</span>
              </li>
            </ul>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild variant="outline">
                <Link to="/pricing">View plans</Link>
              </Button>
              <Button asChild variant="default">
                <Link to="/contact?category=Airtable%20Integration%20Request">Contact us</Link>
              </Button>
            </div>
          </div>
          <div className="flex items-center justify-center p-8 md:p-12">
            <img src={airtableLogo.url} alt="Airtable" className="max-h-52 w-full max-w-md object-contain"/>
          </div>
        </div>
      </Section>

      <PageCta />
    </>);
}

export default Services;
